import React, { useState } from "react";
import UIBody from "../../../components/ui/UIBody";
import { FaMapMarkerAlt, FaUniversity, FaEnvelope, FaEye, FaUserGraduate, FaEnvelopeOpenText, FaGraduationCap } from "react-icons/fa";

const studentsData = [
  { initials: "AJ", name: "Alex Johnson", major: "Computer Science", university: "MIT", location: "New York, NY", email: "alex.johnson@email.com", skills: ["React", "JavaScript", "Node.js", "TypeScript"], experience: "2 years", gpa: 3.8 },
  { initials: "SC", name: "Sarah Chen", major: "Data Science", university: "Stanford University", location: "San Francisco, CA", email: "sarah.chen@email.com", skills: ["Python", "Machine Learning", "TensorFlow"], experience: "1 year", gpa: 3.9 },
  { initials: "MB", name: "Michael Brown", major: "Software Engineering", university: "University of Washington", location: "Seattle, WA", email: "michael.brown@email.com", skills: ["Java", "Spring Boot", "AWS", "Docker"], experience: "3 years", gpa: 3.7 },
  { initials: "JG", name: "Jayesh Gholap", major: "Software Engineering", university: "University of Washington", location: "Seattle, WA", email: "jayesh.gholap@email.com", skills: ["Java", "Spring Boot", "AWS", "Docker"], experience: "3 years", gpa: 3.7 },
  { initials: "YA", name: "Yash Alhat", major: "Software Engineering", university: "University of Washington", location: "Seattle, WA", email: "yash.alhat@email.com", skills: ["Java", "Spring Boot", "AWS", "Docker"], experience: "3 years", gpa: 3.7 },
  { initials: "YB", name: "Yash Abuj", major: "Software Engineering", university: "University of Washington", location: "Seattle, WA", email: "yash.abuj@email.com", skills: ["Java", "Spring Boot", "AWS", "Docker"], experience: "3 years", gpa: 3.7 }
];

const HireUs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleView = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  const filteredStudents = studentsData.filter((student) =>
    `${student.name} ${student.skills.join(" ")} ${student.university}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <UIBody
      content={
        <div className="p-4" style={{ background: "#e9f1ff", minHeight: "100vh" }}>
          <div className="p-4 mb-4 border rounded bg-white">
            <h5 className="fw-bold mb-3">🔎 Filter Students</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name, skills, or university..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <select className="form-select">
                  <option>All Skills</option>
                </select>
              </div>
              <div className="col-md-3">
                <select className="form-select">
                  <option>All Experience</option>
                </select>
              </div>
            </div>
          </div>

          <p className="mb-3 fw-medium">Showing {filteredStudents.length} students</p>

          <div className="row g-4">
            {filteredStudents.map((student, idx) => (
              <div className="col-md-4" key={idx}>
                <div className="p-4 h-100 shadow-sm border rounded bg-white">
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="rounded-circle d-flex justify-content-center align-items-center text-white fw-bold" style={{ width: 50, height: 50, backgroundColor: "#0b4fb3" }}>{student.initials}</div>
                    <div>
                      <h6 className="mb-0 fw-bold">{student.name}</h6>
                      <small className="text-muted">{student.major}</small>
                    </div>
                  </div>
                  <p className="mb-1"><FaUniversity className="me-2 text-muted" /> {student.university}</p>
                  <p className="mb-1"><FaMapMarkerAlt className="me-2 text-muted" /> {student.location}</p>
                  <p className="mb-0"><FaEnvelope className="me-2 text-muted" /> {student.email}</p>
                  <p className="mt-3 fw-bold">Skills:</p>
                  <div className="d-flex flex-wrap gap-2">
                    {student.skills.map((skill, i) => (
                      <span key={i} className="bg-light px-3 py-1 rounded-pill border text-dark">{skill}</span>
                    ))}
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <small className="text-muted">Experience: {student.experience}</small>
                    <small className="text-muted">GPA: {student.gpa}</small>
                  </div>
                  <div className="d-flex align-items-center gap-2 mt-4">
                    <button className="btn btn-primary w-100" style={{ borderRadius: "8px" }}>Send Hire Request</button>
                    <button onClick={() => handleView(student)} className="btn btn-outline-secondary" style={{ width: "42px", height: "42px", borderRadius: "8px" }}><FaEye /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {showModal && selectedStudent && (
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content p-4">
                  <div className="modal-header border-0">
                    <h5 className="modal-title">{selectedStudent.name}'s Profile</h5>
                    <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                  </div>
                  <div className="modal-body">
                    <div className="d-flex align-items-center gap-3 mb-4">
                      <div className="rounded-circle d-flex justify-content-center align-items-center text-white fw-bold" style={{ width: 60, height: 60, backgroundColor: "#0b4fb3", fontSize: 20 }}>{selectedStudent.initials}</div>
                      <div>
                        <h5 className="fw-bold mb-0">{selectedStudent.name}</h5>
                        <span className="text-muted">{selectedStudent.major}</span>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <p><FaEnvelope className="me-2 text-muted" /><strong>{selectedStudent.email}</strong></p>
                        <p><FaMapMarkerAlt className="me-2 text-muted" />{selectedStudent.location}</p>
                      </div>
                      <div className="col-md-6">
                        <p><FaGraduationCap className="me-2 text-muted" /><strong>{selectedStudent.university}</strong></p>
                        <p><FaUserGraduate className="me-2 text-muted" /> GPA: <strong>{selectedStudent.gpa}</strong></p>
                      </div>
                    </div>
                    <h6 className="fw-bold">Experience</h6>
                    <p>{selectedStudent.experience} of professional experience</p>
                    <h6 className="fw-bold">Skills & Expertise</h6>
                    <div className="d-flex flex-wrap gap-2 mb-4">
                      {selectedStudent.skills.map((skill, i) => (
                        <span key={i} className="bg-light px-3 py-1 rounded-pill border text-dark">{skill}</span>
                      ))}
                    </div>
                    <h6 className="fw-bold mb-3">Academic Information</h6>
                    <div className="p-3 rounded" style={{ backgroundColor: "#f8f9fa", fontSize: "0.95rem" }}>
                      <div className="row">
                        <div className="col-md-6">
                          <p className="mb-1">Major</p>
                          <strong>{selectedStudent.major}</strong>
                        </div>
                        <div className="col-md-6">
                          <p className="mb-1">University</p>
                          <strong>{selectedStudent.university}</strong>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-6">
                          <p className="mb-1">GPA</p>
                          <strong>{selectedStudent.gpa}</strong>
                        </div>
                        <div className="col-md-6">
                          <p className="mb-1">Experience</p>
                          <strong>{selectedStudent.experience}</strong>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mt-4">
                      <button className="btn btn-primary w-100">Send Hire Request</button>
                      <button className="btn btn-outline-secondary ms-2"><FaEnvelopeOpenText className="me-2" />Contact</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      }
    />
  );
};

export default HireUs;